import Cg6149 from "../../../images/about/cg6149.png";
import Ernestm from "../../../images/about/ernestm.jpg";
import Ih2422 from "../../../images/about/ih2422.jpg";
import Jt1065 from "../../../images/about/jt1065.jpg";
import Ab0824 from "../../../images/about/ab0824.jpg";
import Jt7347 from "../../../images/about/jt7347.jpg";
import An4978 from "../../../images/about/an4978.jpg";
import Mh6419 from "../../../images/about/mh6419.jpg";
import lglisic from "../../../images/about/lglisic.jpg";
import Fh9696 from "../../../images/about/fh9696.jpg";
import Gn7269 from "../../../images/about/gn7269.jpg";

export const adminData = [
  {
    name: "Alecia Barbieri",
    roles: ["Co-President 2022-24"],
    gradYear: "Class of 2025",
    years: ["2023 - 2024", "2022 - 2023"],
    major: "Electrical & Computer Engineering",
    image: Ab0824,
  },
  {
    name: "Ernest McCarter",
    roles: ["Co-President 2022-24"],
    years: ["2023 - 2024", "2022 - 2023"],
    gradYear: "Class of 2024",
    major: "Computer Science",
    image: Ernestm,
  },
  {
    name: "Jimmy Tran",
    roles: ["Co-President 2022-23"],
    years: ["2022 - 2023"],
    gradYear: "Class of 2025",
    major: "Mechanical & Aerospace Engineering",

    image: Jt7347,
  },
  {
    name: "Ian Henriques",
    roles: ["Co-President 2023-24", "Admin Member 2022-25"],
    years: ["2022 - 2023", "2023 - 2024", "2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Ih2422,
  },
  {
    name: "Freddy Hernandez",
    roles: ["Administrative Officer 2024 - 2025"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Fh9696,
  },
  {
    name: "Andy Nguyen",
    roles: ["Treasurer 2023-24"],
    gradYear: "Class of 2025",
    years: ["2023 - 2024"],
    major: "Electrical & Computer Engineering",
    image: An4978,
  },
  {
    name: "Lana Glisic",
    roles: ["Training Lead 2022-23"],
    gradYear: "Class of 2026",
    years: ["2022 - 2023"],
    major: "Computer Science",
    image: lglisic,
  },
  {
    name: "Maria Hefferman",
    roles: ["Training Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Mh6419,
  },
  {
    name: "Jack Toubes",
    roles: ["Administrative Officer 2022-24"],
    gradYear: "Class of 2025",
    years: ["2022 - 2023", "2023 - 2024", "2024 - 2025"],
    major: "Electrical & Computer Engineering",
    image: Jt1065,
  },
  {
    name: "Chris Ganter",
    roles: ["Administrative Officer 2023-24"],
    gradYear: "Class of 2027",
    years: ["2023 - 2024"],
    major: "Electrical & Computer Engineering",
    image: Cg6149,
  },
  {
    name: "Glen Nfor",
    roles: ["Web Development\nCo-Lead 2023-24"],
    gradYear: "Class of 2027",
    years: ["2023 - 2024"],
    major: "Electrical & Computer Engineering",
    image: Gn7269,
  },
];
